<section *ngIf="isLoading">
  <nz-skeleton [nzActive]="true"
               [nzLoading]="isLoading"
               [nzTitle]="false"
               [nzParagraph]="{ rows: 2 }">
  </nz-skeleton>
</section>
<rappider-title-toolbar *ngIf="!isLoading"
                        [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton">
</rappider-title-toolbar>

<section>
  <rappider-list-grid [config]="PROJECT_MODEL_LIST_CONFIG"
                      [data]="projectModels"
                      [loading]="isLoading"
                      (listActionDropdownItemClick)="onListActionDropdownItemClick($event)"
                      (columnActionClick)="onClickDelete($event)"></rappider-list-grid>
</section>

<ng-template #deleteConfirmationTemplate>
  <div *ngIf="deletedProjectModel.fields">
    <strong> {{'PROJECT_MODULE.PROJECT_MODEL_LIST_COMPONENT.FIELDS' | translate}}:</strong>
    <ul>
      <li *ngFor="let dataField of deletedProjectModel.fields">
        {{dataField.name}}
      </li>
    </ul>
  </div>

  <div *ngIf="deletedProjectModel.relations">
    <strong> {{'PROJECT_MODULE.PROJECT_MODEL_LIST_COMPONENT.RELATIONS' | translate}}:</strong>
    <ul>
      <li *ngFor="let relation of deletedProjectModel.relations">
        {{relation.name}}
      </li>
    </ul>
  </div>
</ng-template>

<nz-modal [(nzVisible)]="isImportProjectModelModalVisible"
          nzWidth="70%"
          [nzTitle]="importProjectModelModalData?.modalTitle"
          [nzOkText]="'SHARED.SAVE' | translate"
          [nzClosable]="true"
          [nzMaskClosable]="false"
          (nzOnCancel)="closeModal()"
          (nzOnOk)="onSaveImportProjectModelData(importProjectModelModalData)">
  <ng-container *nzModalContent>
    <div *ngIf="!(importProjectModelModalData.importType === ImportProjectModelOption.ImportFromPostgreSQL ||
    importProjectModelModalData.importType === ImportProjectModelOption.ImportFromOpenApiSpecs)"
         class="model-name-area">
      <div>
        <span class="required-field-mark">*</span> {{'PROJECT_MODULE.PROJECT_MODEL_CREATE_COMPONENT.PROJECT_MODEL_NAME'
        | translate}}
      </div>

      <rappider-textbox [(ngModel)]="importProjectModelModalData.projectModelName"
                        (ngModelChange)="onModelNameChange($event)"
                        [placeholder]="'SHARED.TITLE_CASE_EXAMPLE' | translate"></rappider-textbox>
      <div class="project-model-name-validation-error"
           *ngIf="hasNamePatternError">
        *{{'ERRORS.PATTERN_MESSAGES.PROJECT_MODEL_NAME_ERROR' | translate}}
      </div>
      <div class="project-model-name-validation-error"
           *ngIf="hasNameRequiredError">
        *{{'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE' | translate}}
      </div>
    </div>

    <div class="json-data-area">
      <div>
        <span class="required-field-mark">*</span> {{importProjectModelModalData?.codeEditorTitle}}
      </div>
      <rappider-code-editor [(ngModel)]="importProjectModelModalData.data"
                            [title]="importProjectModelModalData?.codeEditorTitle"
                            [settings]="CODEMIRROR_JSON_SETTINGS"></rappider-code-editor>
      <div class="project-model-name-validation-error"
           *ngIf="hasDataFieldError">
        *{{'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE' | translate}}
      </div>
    </div>
  </ng-container>
</nz-modal>
